
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 307.93 307.93"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h307.93v307.93H0z"}})])]),_c('g',{attrs:{"data-name":"Calque 2"}},[_c('g',{attrs:{"data-name":"Calque 3"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M154 307.93A154 154 0 100 154a154 154 0 00154 154","fill":"#00577b"}})]),_c('g',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10","fill":"none"}},[_c('path',{attrs:{"d":"M207.55 90.38s.91-2.72-.91-8.15c-13.58-22.65-24.45-2.72-23.55 7.24-28.08 12.69-40.76 8.16-40.76 8.16s-25.33-6.34-40.76-2.72c-88.78 29-40.77 99.64-40.77 99.64a50.68 50.68 0 012-6.16c1.88-4.67 5-10.22 9.3-9.69 7.24.91 12.68-.91 13.58 19 0 .73.1 1.42.2 2.08 2.58 17.66 27 15.13 27 15.13s111.42.91 122.29 12.69-13.58 6.4-13.58 6.4-11.78-4.53-115.95-1.81c-34.42-.91-37.14-24.46-37.14-24.46l-6.13-18.12"}}),_c('path',{attrs:{"d":"M207.78 86.79s25.59-.49 41.89 11.29c9.06 6.34-2.94 20.1-20.95 26.81-12.56.37-25.25-1.45-29.78 9.42s-9.05 15.4-11.77 18.12 9.06 26.27 16.3 29.89 21.74 15.4 10 16.31-16.31 4.53-24.46-8.15-29.89-35.33-58.88-12.69c-3.62-6.34-.26-4.67 2.59-29S92.05 118 92.05 118m38.05 59.79s-9.1 11.78 10.9 11.78c8.15 1.81 19.93 8.15 7.25 13.59h-30l-12.55-20.84m4.85 8.16l-24.64 9.32"}})])])])])
          )
        }
      }
    